import { Component, OnInit, TemplateRef, ViewChild, effect } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { TeamManagementService } from 'src/app/_services/new-settings/team-management.service';
import { TransactionService } from 'src/app/_services/transaction.service';
import * as _underscore from 'underscore';

@Component({
    selector: 'app-credits',
    templateUrl: './credits.component.html',
    styleUrls: ['./credits.component.scss'],
    standalone: false
})
export class CreditsComponent implements OnInit {

  allActivity: Object[] = [];
  activityEmptyState: Boolean = false;
  showCreateTeamCreditPoolTab: Boolean = true;
  showAddCreditToTeamPool: Boolean = false;
  showActivityTab: Boolean = false;
  showTeamCreditPoolTab: Boolean = true;
  planDetails: any;
  successMessage: string = '';
  errorMessage: string = '';
  activityLogs: any[] = [];
  creditInput: UntypedFormControl = new UntypedFormControl(null);
  creditExceedError: boolean = false;
  showSpinnerLoader: Boolean = false;
  creditBelowError: boolean = false;


  @ViewChild('addCreditTeamPoolModel') addCreditTeamPoolModel: TemplateRef<any>; 

  constructor(
    private localstorageservice: LocalStorageService,
    private transactionService: TransactionService,
    private teammanagementservice: TeamManagementService,
    private modalService: NgbModal
  ) {
    effect(() => {
      const creditsData = this.transactionService.credits();
      this.planDetails = creditsData || {};
    });
  }

  ngOnInit() {

    this.fetchUserActivity();

    this.creditInput.valueChanges.subscribe((value) => {
      if (value && Number(value) < 1) {
        this.creditBelowError = true;
      } else if (Number(value) > this.planDetails?.balancebasiccontactenrichmentcredits) {
        this.creditExceedError = true;
      } else {
        this.creditExceedError = false;
        this.creditBelowError = false;
      }
    });

  }



  fetchPlanDetails() {
    // Credits come from the shared signal (populated only on login and after reveal-contact
    // succeeds, see TransactionService) - no direct call to /paymentflow/fetchcurrentplancredits.
    const creditsData = this.transactionService.credits();
    if (creditsData) {
      this.planDetails = creditsData;
    } else {
      this.planDetails = {};
    }
  }

  /**
   * Change Tab
   * @param tab 
   */
  onTabChange(tab: string) {
    switch (tab) {
      case 'team-credit-pool-tab': {
        this.showActivityTab = false;
        this.showTeamCreditPoolTab = true;
        break;
      }

      case 'activity-tab': {
        this.showActivityTab = true;
        this.showTeamCreditPoolTab = false;
        break;
      }
    }
  };

  /**
   * Create team credit pool bucket
   */
  createTeamCreditPool() {
    const data = {
      usernumber: this.localstorageservice.getItem('usernumber')
    }

    this.teammanagementservice.createTeamCreditPool(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Team Pool Created Successfully!';
        this.showCreateTeamCreditPoolTab = false;
        this.showAddCreditToTeamPool = true;
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';

        this.showCreateTeamCreditPoolTab = true;
        this.showAddCreditToTeamPool = false;
        setTimeout(() => this.errorMessage = '', 5000);
      }
    })
  };


  /**
  * Create team credit pool bucket
  */
  fetchUserActivity() {
    const userNumber = this.localstorageservice.getItem('usernumber')
    this.teammanagementservice.fetchUserActivity(userNumber).subscribe((res: any) => {
      if (res && res.status == 'success') {
        // this.allActivity = res.message;
        this.formatedActivity(res?.message)
        const poolCreated = res?.message.filter((ac: any) => ac.action == 'team_pool_created')
        if (poolCreated && poolCreated.length) {
          this.showCreateTeamCreditPoolTab = false;
          this.showAddCreditToTeamPool = true;
        } else {
          this.showCreateTeamCreditPoolTab = true;
          this.showAddCreditToTeamPool = false;
        }
      } else {
        this.allActivity = [];
      }
    })
  };


  /**
   * Add Credit to team pool open model
   */
  addCreditToTeamPool() {
   this.modalService.open(this.addCreditTeamPoolModel, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });
  };


  /**
   * Api call to add credit in team pool
   */
  addCreditsAPI() {
    if (!this.creditInput?.value) return;
    this.showSpinnerLoader = true;
    const data = {
      // usernumber: this.localstorageservice.getItem('usernumber'),
      addcredittoteampool: this.creditInput?.value
    }

    this.teammanagementservice.addCreditToTeamPool(data).subscribe((res: any) => {
      if (res && res.status == 'success') {
        this.successMessage = 'Credit Updated Successfully!';
        this.fetchPlanDetails();
        this.fetchUserActivity();
        setTimeout(() => this.successMessage = '', 5000);
      } else {
        this.errorMessage = 'Something went wrong';
        setTimeout(() => this.errorMessage = '', 5000);
      }
      this.showSpinnerLoader = false;
      this.dismiss();
    })

  }


  /**
   * Dismiss model
   */
  dismiss() {
    this.modalService.dismissAll()
    this.creditInput.setValue(null);
    this.creditExceedError = false;
    this.showSpinnerLoader = false;
  };


  /**
   * Formate Activity
   * @param activity 
   */
  formatedActivity(activity: any) {

    if (activity && activity.length > 0) {
      return new Promise<any>((resolve, reject) => {
        activity.map(async (value: any, index: number) => {
          if (value.action == 'team_pool_created' && value.tablename == 'teaminvite') {
            this.allActivity.push({
              createdon: value.createdon,
              action: 'Team Pool Created',
              credits: value.newvalue? value.newvalue : 0,
              firstname: value?.firstname,
              lastname: value?.lastname,
              activitydate: value?.createdon
            })
          } else if(value.action == 'team_pool_credit_updated' && value.tablename == 'teaminvite') {
            this.allActivity.push({
              createdon: value.createdon,
              action: 'Added to pool by admin',
              credits: value.newvalue? value.newvalue : 0,
              firstname: value?.firstname,
              lastname: value?.lastname,
              activitydate: value?.createdon
            })
          } else if (value.action == 'user_reassign_credits' && value.tablename == 'teaminvite') {
             this.allActivity.push({
              createdon: value.createdon,
              action: `Assign To ${value.memberfirstname}`,
              credits: value.newvalue? value.newvalue : 0,
              firstname: value?.firstname,
              lastname: value?.lastname,
              activitydate: value?.createdon
            })
          } else if (value.action == 'admin_reassign_credits' && value.tablename == 'users') {
             this.allActivity.push({
              createdon: value?.createdon,
              action: `Assign To ${value?.memberfirstname}`,
              credits: value?.newvalue? value?.newvalue : 0,
              firstname: value?.firstname,
              lastname: value?.lastname,
              activitydate: value?.createdon
            })
          } else if (value.action == 'credit_added_on_team_leave' && value.tablename == 'users') {
             this.allActivity.push({
              createdon: value?.createdon,
              action: `Left team — credits added to pool`,
              credits: value?.newvalue && value?.oldvalue ? Number(value?.newvalue) - Number(value?.oldvalue) : 0,
              firstname: value?.memberfirstname,
              lastname: value?.memberlastname,
              activitydate: value?.createdon
            })
          } else if (value.action == 'credit_added_on_team_join' && value.tablename == 'users') {
             this.allActivity.push({
              createdon: value?.createdon,
              action: `Joined team — credits added to pool`,
              credits: value?.newvalue && value?.oldvalue ? Number(value?.newvalue) - Number(value?.oldvalue) : 0,
              firstname: value?.memberfirstname,
              lastname: value?.memberlastname,
              activitydate: value?.createdon
            })
          } else if (value.action == 'credit_added_on_remove_team' && value.tablename == 'users') {
             this.allActivity.push({
              createdon: value?.createdon,
              action: `Removed from team — credits added to pool`,
              credits: value?.newvalue && value?.oldvalue ? Number(value?.newvalue) - Number(value?.oldvalue) : 0,
              firstname: value?.memberfirstname,
              lastname: value?.memberlastname,
              activitydate: value?.createdon
            })
          }

          if (index == activity.length - 1) {
            this.allActivity = _underscore.sortBy(this.allActivity, function (o: any) { return o.activitydate; }).reverse()
            resolve(this.allActivity)
          }

        })
      })

    } else {
      this.allActivity = [];
    }
  }

}
